import { X } from "lucide-react";
import { getLegalDocument, type LegalDocumentKind } from "../content/legalDocuments";
import { type Language } from "../types/siteContent";

type Props = {
  kind: LegalDocumentKind;
  language: Language;
  closeLabel?: string;
  onClose: () => void;
};

export function LegalDocumentModal({ kind, language, closeLabel, onClose }: Props) {
  const document = getLegalDocument(kind, language);
  const titleId = `legal-document-${kind}-title`;

  return (
    <div className="legal-modal-backdrop" role="presentation" onClick={onClose}>
      <section
        className="legal-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <button className="icon-button modal-close" type="button" onClick={onClose} aria-label={closeLabel || "关闭"}>
          <X size={18} />
        </button>
        <header className="legal-modal-header">
          <p>{language === "en" ? "Effective date" : "生效日期"}：{document.effectiveDate}</p>
          <h2 id={titleId}>{document.title}</h2>
        </header>
        <div className="legal-modal-body">
          {document.sections.map((section, index) => (
            <section className="legal-section" key={`${section.title || "intro"}-${index}`}>
              {section.title ? <h3>{section.title}</h3> : null}
              {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {section.items?.length ? (
                <ul>
                  {section.items.map((item) => <li key={item}>{item}</li>)}
                </ul>
              ) : null}
            </section>
          ))}
        </div>
      </section>
    </div>
  );
}
